import { Archive, Building2, FileDown, LayoutDashboard, MapPin, Scale, Search, Wallet } from 'lucide-react';
import type { NavSection } from '@flexibilitypay/ui';

import { ROUTES } from '../routes/routes-config';

// Solo las pantallas con ruta real registrada en el router (ver app.tsx).
// Resto pendiente: usuarios, cvus, transacciones (listado), conciliación,
// compliance, webhooks, configuración — restituir al sidebar a medida que
// se vayan cableando para evitar enlaces rotos en el BO.
/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @taskId T653
 * @taskId T657
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-29-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-99-FE
 */
export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ label: 'Dashboard', to: ROUTES.DASHBOARD, icon: LayoutDashboard }],
  },
  {
    title: 'Operaciones',
    items: [
      { label: 'Cuentas por CUIT', to: ROUTES.ACCOUNTS_BY_CUIT, icon: Search },
      { label: 'Saldo', to: ROUTES.BALANCE, icon: Wallet },
    ],
  },
  {
    title: 'Backoffice',
    items: [
      { label: 'Merchants', to: ROUTES.MERCHANTS, icon: Building2 },
      { label: 'Cuentas BO', to: ROUTES.ACCOUNTS_BO, icon: Search },
      { label: 'Limites BO', to: ROUTES.LIMITS, icon: Scale },
      { label: 'Reportes', to: ROUTES.REPORTS, icon: FileDown },
      { label: 'Paquetes regulatorios', to: ROUTES.REGULATORY_PACKAGES, icon: Archive },
    ],
  },
  {
    title: 'Catálogos',
    items: [{ label: 'Provincias', to: ROUTES.PROVINCIAS, icon: MapPin }],
  },
];
